import React, {useRef, useState, useEffect} from 'react';
import Switch from "react-bootstrap-switch";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import {connect, useSelector} from 'react-redux'
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

// components
import HotelCategoryLangs from "./_langs";
import SelectGeneric from "../../../components/select/selectGeneric";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import {getStateByPath} from "../../../redux/selectors";
import ImagePicker from "../../../components/imagePickerComponents/ImagePicker";

// labels
import { INTERNATIONAL, LB_ACTIVE, LB_CODE, REQUIRED } from "../../../components/i18n/i18n";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {PH_CODE, PH_ICON, PH_NEXT_VIEW} from "../../../components/i18n/placeHolders";
import {
	FL_FATHER_CATEGORY, FL_GENERAL_CATEGORY,
	FL_ICON, FL_NEXT_VIEW,
	FL_SHOW_IN_HOME,
	FL_TYPE_VIEW
} from "../../../components/i18n/formLabels";

// actions
import { setDataToEdit, setEditMode, setEnabledForm, setFormInfo } from "../../../redux/actions/genericActions";
import { saveCategory, updateCategory } from "../../../redux/actions/categoryActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// providers
import {typeViewProvider} from "../../../providers/typeViewProvider";
import { hotelCategoryProvider } from "../../../providers/hotelCategoryProvider";

// utils
import { getCurrentDateForCodeField } from "../../../util/DateTools";

// services
import {hotelCategoryService} from "../../../jwt/_services/hotel/hotelCategoryService";
import { hotelCategoryMediaService } from "../../../jwt/_services/core/hotelCategoryMediaService";

const HotelCategoryForm = props => {
	const componentState = useSelector(state => getStateByPath(state, props.path));
	const { path } = componentState;
	const { app, udn, editMode, domainObject, userIsAdmin} = componentState?.data;

	const fbDataBase = {id: app?.fbDataBase?.id}
	const translatableLangs = domainObject?.translatedLangs || []

	const [showInHome, setShowInHome] = useState(domainObject?.showInHome || false);
	const [status, setStatus] = useState(domainObject?.status || false)
	const [parent, setParent] = useState(domainObject?.parent?.id || null);
	const [typeView, setTypeView] = useState(domainObject?.typeView || null);
	const [usoGeneral, setUsoGeneral] = useState(domainObject?.general || false)
	const [langs, setLangs] = useState(domainObject?.langs || []);

	const [showModal, setShowModal] = useState(true)

	const modalRef = useRef(null);






	// Actualiza el formulario con los datos del objeto de dominio
	// Se utiliza posterior a la carga de imagenes desde ImagePicker ejecutando el metodo refresh()
	useEffect(() => {
		if (domainObject && domainObject.id && domainObject.langs) {
			reset({
				id: domainObject?.id,
				uid: domainObject?.uid,
				code: domainObject?.code,
				icon: domainObject?.icon,
				priority: domainObject?.priority,
				nextView: domainObject?.nextView,
				navigationUrl: domainObject?.navigationUrl,
				userIsAdmin: userIsAdmin
			})
			setLangs(domainObject.langs || []);
			setStatus(domainObject.status);
		}
	}, [ domainObject ]);







	const showHistory = () => {
		setShowModal(true);
		modalRef.current.showModal(domainObject);
	}

	const validationSchema = Yup.object().shape({
		code: Yup.string().when('userIsAdmin',{
			is: true,
			then: Yup.string().required( REQUIRED ),
			otherwise: Yup.string()
		}),
		userIsAdmin: Yup.boolean()
	});

	const {register, reset, handleSubmit, errors} = useForm({
		validationSchema: validationSchema,
		defaultValues: {
			id: domainObject?.id,
			uid: domainObject?.uid,
			code: domainObject?.code,
			icon: domainObject?.icon,
			priority: domainObject?.priority,
			nextView: domainObject?.nextView,
			navigationUrl: domainObject?.navigationUrl,
			userIsAdmin: userIsAdmin
		}
	});

	const onSubmit = (data, _) => {
		const requestData = {
			fbDataBase,
			item: {
				...data,
				showInHome,
				status,
				langs,
				genericCategory: false,
			}
		}

		if(!data?.code || data?.code === "") {
			const code = `${udn?.code}_CAT_` + getCurrentDateForCodeField()
			requestData.item.code = code.toLowerCase()
		}

		if(!usoGeneral)
			requestData.item.udn = { id : udn?.id }
		else {
			requestData.item.genericCategory = true

			if(udn?.code.trim().toUpperCase() === 'FE')
				requestData.item.udn = { id : udn?.id }
		}

		requestData.item.parent = (parent !== undefined && parent !== null) ? { id : parent } : null
		requestData.item.typeView = (typeView !== null) ? typeView: null

		if (!editMode)
			genericIndexedActions.save(path, hotelCategoryService, requestData)
		else {
			let id = domainObject.id;
			requestData.item.id = domainObject?.id

			genericIndexedActions.update(path, hotelCategoryService, id, requestData)
		}

		closeForm()
	};

	const closeForm = () => props.onClose()

	const refreshObject = () => genericIndexedActions.get(path, hotelCategoryService, domainObject?.id, fbDataBase.id);

	return <Form onSubmit={handleSubmit(onSubmit)}>
		<Card className={'card-modal'}>
			<CardTitle className="bg-light border-bottom p-3 mb-0">
				<>
					<h2 className={'card-modal-title'} > { (udn?.value || '') + ' / ' + (domainObject?.title || domainObject?.name || '') }</h2>
					<br />
					<h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
				</>
				<div className={'top-right'}>
					<GenericButton
						style={'table'}
						icon={'fa-save'}
						toolTip={TT_SAVE}
						permission={'add'}
						type={'submit'}
					/>
					{
						editMode && <>
							<GenericButton
								style={'table'}
								toolTip={TT_HISTORY}
								icon={'fa-clock'}
								permission={'search'}
								onClick={showHistory}
							/>
						</>
					}
					<Separator/>
					<GenericButton
						style={'danger-secondary'}
						toolTip={TT_CLOSE}
						icon={'fa-times'}
						permission={'search'}
						onClick={closeForm}
					/>
				</div>
			</CardTitle>
			<CardBody className={'card-body-modal'}>
				<Row>
					<Col md="8">
						<Row>
							{
								userIsAdmin ? <Col md="6">
									<FormGroup>
										<Label>{LB_CODE}</Label>
										<Input
											type="text"
											name="code"
											placeholder={PH_CODE}
											innerRef={register}
											className={(errors.code ? ' is-invalid' : '')}
										/>
										{ errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
									</FormGroup>
								</Col> : <Input
									type="hidden"
									name="code"
									placeholder={PH_CODE}
									innerRef={register}
									className={(errors.code ? ' is-invalid' : '')}
								/>
							}
							<Col md="6">
								<FormGroup>
									<Label>{FL_FATHER_CATEGORY}</Label>
									<SelectGeneric
										initialValue = { parent }
										setExternalValue = { setParent }
										isDisabled = { false }
										provider = { hotelCategoryProvider }
										customFilter={{ item: {udn: { id: udn?.id }} }}
									/>
								</FormGroup>
							</Col>

						</Row>
						<Row>
							<Col md="3">
								<FormGroup>
									<Label>{FL_ICON}</Label>
									<Input
										type="text"
										name="icon"
										placeholder={PH_ICON}
										innerRef={register}
									/>
								</FormGroup>
							</Col>
							<Col md="3">
								<FormGroup>
									<Label>{FL_SHOW_IN_HOME}</Label>
									<br/>
									<Switch
										animate={true}
										offText={"No"}
										onText={"Si"}
										value={showInHome}
										onChange={_ => setShowInHome(!showInHome)}
									/>
								</FormGroup>
							</Col>
							<Col md="3">
								<FormGroup>
									<Label>{LB_ACTIVE}</Label>
									<br/>
									<Switch
										animate={true}
										offText={"No"}
										onText={"Si"}
										value={status}
										onChange={() => setStatus(!status)}
									/>
								</FormGroup>
							</Col>
							{
								userIsAdmin && <Col md="3">
									<FormGroup>
										<Label>{FL_GENERAL_CATEGORY}</Label>
										<br/>
										<Switch
											animate={true}
											offText={"No"}
											onText={"Si"}
											value={usoGeneral}
											onChange={(item,val)=>setUsoGeneral(val)}
										/>
									</FormGroup>
								</Col>
							}
						</Row>
						<Row>
							<Col md="4">
								<FormGroup>
									<Label>{FL_NEXT_VIEW}</Label>
									<Input
										type="text"
										name="nextView"
										placeholder={PH_NEXT_VIEW}
										innerRef={register}
									/>
								</FormGroup>
							</Col>
							<Col md="4">
								<FormGroup>
									<Label>{FL_TYPE_VIEW}</Label>
									<br/>
									<SelectGeneric
										initialValue = { typeView }
										setExternalValue = { value => setTypeView( value ) }
										provider = { typeViewProvider }
									/>
								</FormGroup>
							</Col>
							<Col md="4">
								<FormGroup>
									<Label>{'Orden'}</Label>
									<Input
										type="number"
										name="priority"
										min="0"
										innerRef={register}
									/>
								</FormGroup>
							</Col>
							<Col md="6">
								<FormGroup>
									<Label>{'Url de navegación'}</Label>
									<Input
										type="text"
										name="navigationUrl"
										placeholder={'Url de navegación'}
										innerRef={register}
									/>
								</FormGroup>
							</Col>
						</Row>
					</Col>
					<Col md="4">
						<ImagePicker
							className={'hotelCategory'}
							title={'Media Categoría de Hotel'}
							app={app}
							service={hotelCategoryService}
							baseMediaService={hotelCategoryMediaService}
							objectMedia={domainObject}
							afterUpload={refreshObject}
						/>
					</Col>
				</Row>
				<Row>
					<Col md="12">
						<CardTitle className="bg-light border-bottom p-3 mb-0">
							<i className="fas fa-language mr-2"/>
							{INTERNATIONAL}
						</CardTitle>
						<CardBody>
							<HotelCategoryLangs
								langs={langs}
								setLangs={setLangs}
								translatableLangs={translatableLangs}
							/>
						</CardBody>
					</Col>
				</Row>
			</CardBody>
			{
				showModal && <LogHistoryModal
					ref={ modalRef }
					item={ domainObject }
				/>
			}
		</Card>
	</Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
	setFormInfo,
	setDataToEdit,
	setEnabledForm,
	setEditMode,
	saveCategory,
	updateCategory,
})

export default connect(mapStateToProps, mapActionsToProps)(HotelCategoryForm)